/* tslint:disable */
import {
  HazardTemplate,
  Control
} from '../index';

declare var Object: any;
export interface ControlTemplateInterface {
  "description": string;
  "hazardTemplateId"?: any;
  "hidden": boolean;
  "id"?: any;
  hazardTemplate?: HazardTemplate;
  controls?: Control[];
}

export class ControlTemplate implements ControlTemplateInterface {
  "description": string;
  "hazardTemplateId": any;
  "hidden": boolean;
  "id": any;
  hazardTemplate: HazardTemplate;
  controls: Control[];
  constructor(data?: ControlTemplateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ControlTemplate`.
   */
  public static getModelName() {
    return "ControlTemplate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ControlTemplate for dynamic purposes.
  **/
  public static factory(data: ControlTemplateInterface): ControlTemplate{
    return new ControlTemplate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ControlTemplate',
      plural: 'ControlTemplates',
      path: 'ControlTemplates',
      idName: 'id',
      properties: {
        "description": {
          name: 'description',
          type: 'string'
        },
        "hazardTemplateId": {
          name: 'hazardTemplateId',
          type: 'any'
        },
        "hidden": {
          name: 'hidden',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        hazardTemplate: {
          name: 'hazardTemplate',
          type: 'HazardTemplate',
          model: 'HazardTemplate',
          relationType: 'belongsTo',
                  keyFrom: 'hazardTemplateId',
          keyTo: 'id'
        },
        controls: {
          name: 'controls',
          type: 'Control[]',
          model: 'Control',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'controlTemplateId'
        },
      }
    }
  }
}
